module.exports = __webpack_public_path__ + "img/setting_12.5193c0a5.svg";